import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ProtectedRoute from "./pages/ProtectedRoute";
import { AuthProvider } from "./pages/AuthContext";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard";
import Notfound from "./pages/Notfound";
import Subscription from "./components/Subscription";
import Addcontacts from "./components/Addcontacts";
import Inactivecontacts from "./components/Inactivecontacts";
import Createpost from "./components/Createpost";
import Whatsapphistory from "./components/Whatsapphistory";
import Contactdivion from "./components/Contactdivion";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>

          <Route path="/contacts-division" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route path="/contacts-division" element={<Contactdivion />} />
          </Route>

           <Route path="/whatsapp-history" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route path="/whatsapp-history" element={<Whatsapphistory />} />
          </Route>

           <Route path="/send-whatsapp" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route path="/send-whatsapp" element={<Createpost />} />
          </Route>

          <Route path="/active-contacts" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route path="/active-contacts" element={<Addcontacts />} />
          </Route>


          <Route path="/inactive-contacts" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route path="/inactive-contacts" element={<Inactivecontacts />} />
          </Route>

          <Route path="*" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route path="*" element={<Notfound />} />
          </Route>

          <Route path="/" element={<ProtectedRoute allowedRole="Superadmin"><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />


        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
